<template>
<div class="box">
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">
			<h2>{{ 'contact' | translate | capitalize }}</h2>
			</div>
			<div class="box__header__edit" @click="toggleEditProfile">
			<p>{{ 'edit' | translate | capitalize }}</p>
			</div>
		</div>
		<div class="box__body">
			<div class="box__body__subtitle">
				<p>{{ 'contact-title' | translate | capitalize }}</p>
			</div>

			<form @submit.prevent="registerContact">
				<div class="form__group">
						<label>{{ 'WhatsApp' | capitalize}}</label>
						<input type="tel" name="cellphone" v-model="contact.cellphone" v-mask="'(99)99999-9999'" :disabled="!this.toggleEdit">
					<div class="has-error" v-show="errorForm(error, 'cellphone')">
						<label class="control-label" for="cellphone">{{ 'required-field' | translate | capitalize }}</label>
					</div>
				</div>
				<div class="form__group">
						<label>{{ 'email' | translate | capitalize}}</label>
						<input type="email" maxlength="256" name="email" v-model="contact.email" :disabled="!this.toggleEdit">
					<div class="has-error" v-show="errorForm(error, 'email')">
						<label class="control-label" for="email">{{ 'required-field' | translate | capitalize }}</label>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'Twitter' | capitalize}}</label>
					<input type="text" name="twitter" maxlength="15" v-model="contact.twitter" :disabled="!this.toggleEdit">
					<div class="has-error" v-show="errorForm(error, 'twitter')">
						<label class="control-label" for="twitter">{{ 'required-field' | translate | capitalize }}</label>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'Website' | capitalize}}</label>
					<input type="text" name="url" v-model="contact.url" @focus="_updateMask" @input="_updateMask" :disabled="!this.toggleEdit">
					<div class="has-error" v-show="errorForm(error, 'url')">
						<label class="control-label" for="url">{{ 'required-field' | translate | capitalize }} </label>
					</div>
				</div>

				<div class="form__group submit__content">
					<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'" :disabled="!this.toggleEdit">
						{{ 'save' | translate | capitalize }}
					</button>
					<div class="has-success-message" v-show="successMsg">
						<template class="control-label">
							<i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}
						</template>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

</template>

<script>
	import AwesomeMask from 'awesome-mask';

	export default {
		name: 'contact',
		data() {
			return {
				maskUrl: '',
				erro: false,
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
				submitLoading: false,
				successMsg: false,
				toggleEdit: false,
			};
		},
		directives: {
			mask: AwesomeMask,
		},
		filters: {
			capitalize(value) {
				let str = '';
				if (!value) return '';
				str = value.toString();
				return str.charAt(0).toUpperCase() + str.slice(1);
			},
		},
		computed: {
			contact() {
				return this.$store.state.profile.contact.politician_contact;
			},
			error() {
				return this.$store.state.error;
			},
			success() {
				return this.$store.state.status;
			},
		},
		methods: {
			toggleEditProfile() {
				this.toggleEdit = !(this.toggleEdit);
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			_updateMask(e) {
				let elemValue = e.target.value;
				if (elemValue.indexOf('http:') < 0) {
					if (elemValue.search('/[http]/')) {
						elemValue = '';
					}
					this.contact.url = `http://${elemValue}`;
				}
			},
			registerContact() {
				const payload = {};

				if (this.contact.cellphone) {
					payload.cellphone = `+${'55'}${this.contact.cellphone.replace(/[\\()\-\\+,]/g, '')}`;
				}

				if (this.contact.url) {
					payload.url = this.contact.url;
				}

				if (this.contact.twitter) {
					payload.twitter = this.contact.twitter;
				}

				if (this.contact.email) {
					payload.email = this.contact.email;
				}

				this.toggleSubmitLoading();
				this.$store.dispatch('postContact', payload)
					.then(() => {
						this.$store.dispatch('getContact', this.session);
						this.toggleSubmitLoading();
						this.successMsg = this.success;
						setTimeout(() => {
							this.successMsg = false;
						}, 5000);
						this.toggleEditProfile();
					})
					.catch(() => {
						this.toggleSubmitLoading();
					});
			},
			errorForm(obj, field) {
				let erro = false;
				if (obj) {
					if (obj[field]) {
						erro = true;
					}
				}
				return erro;
			},

			collapsePainel(event) {
				$.AdminLTE.boxWidget.collapse($(event.target));
			},
		},
		mounted() {
			this.$store.dispatch('getContact', this.session);
		},
	};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/profile/contact.vue